import { snakeCase } from "change-case"
import { SnakeCasedProperties } from "type-fest"

type ConvertObj = Required<Record<string, any>>

// Util for converting the keys of an object using a provided
// convertMethod, such as snakeCase.
const convertObjectKeys = <T extends ConvertObj>(
  obj: T,
  convertMethod: (key: string) => string
) => {
  if (!obj) return obj
  if (typeof obj !== "object") return obj

  // Convert the object's keys using the provided convertMethod.
  const convertedObj = Object.entries(obj).reduce(
    (obj, [key, value]) => ({
      ...obj,
      [convertMethod(key)]: value
    }),
    {}
  )

  return convertedObj
}

export const convertObjectKeysToSnakeCase = <T extends ConvertObj>(obj: T) =>
  convertObjectKeys(obj, snakeCase) as SnakeCasedProperties<T>

export default convertObjectKeys
